import { postV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryProcedureIdVerify } from 'src/client/spendesk-api';
import type { PostV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryProcedureIdVerifyRequest } from 'src/client/spendesk-api-types';
import { logger } from 'src/utils/datadog-log-wrapper';

export type PostRecoveryFactorScaOperationStatusInput = {
  authenticationMethod: PostV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryProcedureIdVerifyRequest['body']['authenticationMethod'];
  companyId: string;
  procedureId: string;
  shareMethod: PostV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryProcedureIdVerifyRequest['body']['shareMethod'];
  userId: string;
};

type PostRecoveryFactorScaOperationStatusResponse =
  | {
      procedureStatus: 'pending' | 'rejected' | 'timeout';
    }
  | {
      procedureStatus: 'approved';
      output: {
        backupCode?: string;
      };
    };

export const postInitiateRecoveryFactorScaOperationStatus = async ({
  authenticationMethod,
  companyId,
  procedureId,
  shareMethod,
  userId,
}: PostRecoveryFactorScaOperationStatusInput): Promise<PostRecoveryFactorScaOperationStatusResponse> => {
  const { statusCode, body } =
    await postV2ApiCompanyIdUsersUserIdAuthenticationFactorsRecoveryProcedureIdVerify(
      {
        path: {
          companyId,
          procedureId,
          userId,
        },
        body: {
          authenticationMethod,
          shareMethod,
        },
      },
    );

  if (statusCode !== 200) {
    logger.error('Failed to get recovery factor SCA operation status.', {
      error: body,
      scope: 'user-authentication-factors',
      team: 'cards-ux',
    });
    throw new Error('Failed to get recovery factor SCA operation status.');
  }

  const { procedureStatus } = body;

  if (procedureStatus !== 'approved') {
    return {
      procedureStatus,
    };
  }

  const { backupCode } = body;

  return {
    procedureStatus,
    output: {
      backupCode,
    },
  };
};
